// extracted by mini-css-extract-plugin
module.exports = {"form":"UserForm_form__3tzoq"};